/**
 * NOTE: this is an autogenerated file! do not change!
 * to change feature imports, edit /apps/<name>/shared/features.json!
 */

import {CoreBaseFeature} from "@common/core/feature";
import {MessagesBaseFeature} from "@common/messages/feature";
import {DocumentationBaseFeature} from "@common/documentation/feature";
import {MailBaseFeature} from "@common/mail/feature";
import {ConsoleBaseFeature} from "@common/console/feature";
import {AbilitiesBaseFeature} from "@common/abilities/feature";
import {MediaBaseFeature} from "@common/media/feature";
import {CloudinaryBaseFeature} from "@common/cloudinary/feature";
import {FaqBaseFeature} from "@common/faq/feature";
import {MaintenanceBaseFeature} from "@common/maintenance/feature";
import {NotificationsBaseFeature} from "@common/notifications/feature";
import {StatisticsBaseFeature} from "@common/statistics/feature";
import {CmsBaseFeature} from "@common/cms/feature";
import {FeedbackBaseFeature} from "@common/feedback/feature";
import {MailerBaseFeature} from "@common/mailer/feature";
import {UsersBaseFeature} from "@common/users/feature";
import {AccessibilityBaseFeature} from "@common/accessibility/feature";
import {AuthStrategyCredentialsBaseFeature} from "@common/auth-strategy-credentials/feature";
import {TrackingBaseFeature} from "@common/tracking/feature";
import {TaskSchedulerBaseFeature} from "@common/task-scheduler/feature";
import {UsersPasswordResetQrcodeBaseFeature} from "@common/users-password-reset-qrcode/feature";
import {MembershipBaseFeature} from "@common/membership/feature";
import {PaymentReminderBaseFeature} from "@common/payment-reminder/feature";
import {MpfMembershipPluginPaymentBaseFeature} from "@mpf/membership-plugin-payment/feature";
import {MpfContactBaseFeature} from "@mpf/contact/feature";
import {MpfUsersBaseFeature} from "@mpf/users/feature";
import {MpfCoursesBaseFeature} from "@mpf/courses/feature";
import {MpfDocentsBaseFeature} from "@mpf/docents/feature";
import {MpfAppBaseFeature} from "@mpf/app/feature";
import {MpfOptinUnlockVideoJumpingBaseFeature} from "@mpf/optin-unlock-video-jumping/feature";
import {CoreFrontendSharedFeature} from "@common/core/frontend-shared";
import {CoreFrontendManagementFeature} from "@common/core/frontend-management";
import {MessagesFrontendFeature} from "@common/messages/frontend";
import {ConsoleFrontendSharedFeature} from "@common/console/frontend-shared";
import {MediaFrontendFeature} from "@common/media/frontend";
import {FaqFrontendFeature} from "@common/faq/frontend";
import {MaintenanceFrontendFeature} from "@common/maintenance/frontend";
import {NotificationsFrontendFeature} from "@common/notifications/frontend";
import {UsersFrontendFeature} from "@common/users/frontend";
import {UsersFrontendManagementFeature} from "@common/users/frontend-management";
import {AccessibilityFrontendFeature} from "@common/accessibility/frontend";
import {AuthStrategyCredentialsFrontendFeature} from "@common/auth-strategy-credentials/frontend";
import {TrackingFrontendFeature} from "@common/tracking/frontend";
import {UsersPasswordResetQrcodeFrontendFeature} from "@common/users-password-reset-qrcode/frontend";
import {UsersPasswordResetQrcodeFrontendManagementFeature} from "@common/users-password-reset-qrcode/frontend-management";
import {MembershipFrontendFeature} from "@common/membership/frontend";
import {PaymentReminderFrontendFeature} from "@common/payment-reminder/frontend";
import {MpfContactFrontendFeature} from "@mpf/contact/frontend";
import {MpfUsersFrontendManagementFeature} from "@mpf/users/frontend-management";
import {MpfCoursesFrontendFeature} from "@mpf/courses/frontend";
import {MpfCoursesFrontendManagementFeature} from "@mpf/courses/frontend-management";
import {MpfDocentsFrontendFeature} from "@mpf/docents/frontend";
import {MpfDocentsFrontendManagementFeature} from "@mpf/docents/frontend-management";
import {MpfAppFrontendFeature} from "@mpf/app/frontend";
import {MpfAppFrontendManagementFeature} from "@mpf/app/frontend-management";
import {MpfOptInUnlockVideoJumpingFrontendFeature} from "@mpf/optin-unlock-video-jumping/frontend-shared";
import {clientCacheDevToolProvider} from "@common/core/frontend-shared";
import {DevToolProviderToken} from "@core/shared/dev-tools";
import {modelMetadataDevToolDefinition} from "@common/core/frontend-shared";
import {storeInspectorDevToolDefinition} from "@common/core/frontend-shared";
import {MediaAssetProviderCloudinaryFrontend} from "@common/cloudinary/frontend-shared";
import {MEDIA_ASSET_PROVIDER_TOKEN} from "@common/media/shared";
import {AccessUserPluginFrontend} from "@common/users/frontend-shared";
import {ACCESS_SERVICE_PLUGIN_TOKEN} from "@core/shared/access";
import {AccessMembershipFrontendPlugin} from "@common/membership/frontend";
import {AccessPaymentReminderFrontendPlugin} from "@common/payment-reminder/frontend";
import {MpfPaymentFrontendMembershipPlugin} from "@mpf/membership-plugin-payment/frontend-shared";
import {MEMBERSHIP_PLUGINS_TOKEN} from "@common/membership/shared";
import { CoreFeatureModule } from "@core/frontend-shared";

export default [
	// include base feature info
	CoreFeatureModule.forRoot([
		CoreBaseFeature,
		MessagesBaseFeature,
		DocumentationBaseFeature,
		MailBaseFeature,
		ConsoleBaseFeature,
		AbilitiesBaseFeature,
		MediaBaseFeature,
		CloudinaryBaseFeature,
		FaqBaseFeature,
		MaintenanceBaseFeature,
		NotificationsBaseFeature,
		StatisticsBaseFeature,
		CmsBaseFeature,
		FeedbackBaseFeature,
		MailerBaseFeature,
		UsersBaseFeature,
		AccessibilityBaseFeature,
		AuthStrategyCredentialsBaseFeature,
		TrackingBaseFeature,
		TaskSchedulerBaseFeature,
		UsersPasswordResetQrcodeBaseFeature,
		MembershipBaseFeature,
		PaymentReminderBaseFeature,
		MpfMembershipPluginPaymentBaseFeature,
		MpfContactBaseFeature,
		MpfUsersBaseFeature,
		MpfCoursesBaseFeature,
		MpfDocentsBaseFeature,
		MpfAppBaseFeature,
		MpfOptinUnlockVideoJumpingBaseFeature
	],[
		{token:DevToolProviderToken, value:clientCacheDevToolProvider},
		{token:DevToolProviderToken, value:modelMetadataDevToolDefinition},
		{token:DevToolProviderToken, value:storeInspectorDevToolDefinition},
		{token:MEDIA_ASSET_PROVIDER_TOKEN, value:MediaAssetProviderCloudinaryFrontend},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessUserPluginFrontend},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessMembershipFrontendPlugin},
		{token:ACCESS_SERVICE_PLUGIN_TOKEN, value:AccessPaymentReminderFrontendPlugin},
		{token:MEMBERSHIP_PLUGINS_TOKEN, value:MpfPaymentFrontendMembershipPlugin}
	]),

	// load feature plugins for this platform
	CoreFrontendSharedFeature,
	CoreFrontendManagementFeature,
	MessagesFrontendFeature,
	ConsoleFrontendSharedFeature,
	MediaFrontendFeature,
	FaqFrontendFeature,
	MaintenanceFrontendFeature,
	NotificationsFrontendFeature,
	UsersFrontendFeature,
	UsersFrontendManagementFeature,
	AccessibilityFrontendFeature,
	AuthStrategyCredentialsFrontendFeature,
	TrackingFrontendFeature,
	UsersPasswordResetQrcodeFrontendFeature,
	UsersPasswordResetQrcodeFrontendManagementFeature,
	MembershipFrontendFeature,
	PaymentReminderFrontendFeature,
	MpfContactFrontendFeature,
	MpfUsersFrontendManagementFeature,
	MpfCoursesFrontendFeature,
	MpfCoursesFrontendManagementFeature,
	MpfDocentsFrontendFeature,
	MpfDocentsFrontendManagementFeature,
	MpfAppFrontendFeature,
	MpfAppFrontendManagementFeature,
	MpfOptInUnlockVideoJumpingFrontendFeature
] as const;

